import { SITE_TODAY, daysBetween } from "@/lib/catalog";
import type { Work } from "@/types/work";

export function formatDate(value: string | null | undefined): string {
  if (!value) return "情報未登録";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "情報未登録";
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
}

export function formatShortDate(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, "0")}.${String(date.getDate()).padStart(2, "0")}`;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return `${formatShortDate(value)} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}

export function formatPrice(price: number | null | undefined): string {
  if (price === null || price === undefined) return "情報未登録";
  if (price === 0) return "無料";
  return `¥${price.toLocaleString("ja-JP")}`;
}

export function formatCount(count: number | null | undefined): string {
  if (count === null || count === undefined) return "—";
  return count.toLocaleString("ja-JP");
}

export function formatRelativeDate(value: string): string {
  const diff = daysBetween(value, SITE_TODAY);
  if (diff <= 0) return "今日";
  if (diff === 1) return "昨日";
  if (diff < 7) return `${diff}日前`;
  if (diff < 30) return `${Math.floor(diff / 7)}週間前`;
  if (diff < 365) return `${Math.floor(diff / 30)}か月前`;
  return `${Math.floor(diff / 365)}年前`;
}

export function ratingLabel(rating: number | null): string {
  if (rating === null) return "未評価";
  return rating.toFixed(1);
}

export function workSubtitle(work: Work): string {
  if (work.performers.length > 0) return `${work.creator}／出演：${work.performers.join("・")}`;
  return work.creator;
}

export function truncate(text: string, max: number): string {
  if (text.length <= max) return text;
  return `${text.slice(0, max)}…`;
}